import store from 'store';
import { APP_ROLES } from 'store/enums';
import { CAMPS_GET_MASTER_DATA } from 'store/actions/camps'; // CAMPS_GET_CAR_DETAIL
// import { UI_SET_LOADER } from 'store/actions/ui';

const Layout = () =>
  import(
    /* webpackChunkName: "pages/views/modules/camps/layout-camps" */ 'views/modules/Camps/LayoutCamps'
  );
const ManagerLists = () =>
  import(/* webpackChunkName: "pages/views/modules/camps" */ 'views/modules/Camps');
const CampCarDetail = () =>
  import(
    /* webpackChunkName: "pages/views/modules/camps/car-detail" */ 'views/modules/Camps/CarDetail'
  );
const CarTasks = () =>
  import(
    /* webpackChunkName: "pages/views/modules/camps/car-tasks" */ 'views/modules/Camps/CarTasks'
  );
const PapDetail = () =>
  import(
    /* webpackChunkName: "pages/views/modules/camps/pap-detail" */ 'views/modules/Camps/PapDetail'
  );
const DiscrepancyDetail = () =>
  import(
    /* webpackChunkName: "pages/views/modules/camps/discrepancy-detail" */ 'views/modules/Camps/DiscrepancyDetail'
  );

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

export default [
  {
    path: '/camps',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list' // Redirige a la ruta 'list' por defecto
      },
      {
        path: 'list',
        component: ManagerLists,
        name: 'campsList',
        meta: {
          titleKey: 'campsList',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`camps/${CAMPS_GET_MASTER_DATA}`)
            .then(defaultStorageParks => {
              if (defaultStorageParks) {
                ['carListFilters', 'taskListFilter', 'papsFilter'].forEach(filter => {
                  store.commit(`camps/SET_CAMPS_PROPERTY`, {
                    field: filter,
                    value: {
                      idStoragePark: defaultStorageParks.id
                    }
                  });
                });
              }
              next();
            })
            .catch(() => {
              redirectToErrorPage(next, CAMPS_GET_MASTER_DATA);
            });
        }
      },
      {
        path: 'car/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'campCarDetail',
        component: CampCarDetail,
        meta: {
          titleKey: 'carDetail',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        }
        // beforeEnter(to, from, next) {
        //   const promises = [
        //     store.dispatch(`ui/${UI_SET_LOADER}`, true),
        //     store.dispatch(`camps/${CAMPS_GET_CAR_DETAIL}`, to.params.plate)
        //   ];

        //   Promise.all(promises)
        //     .then(() => next())
        //     .catch(() => {
        //       redirectToErrorPage(next, CAMPS_GET_CAR_DETAIL);
        //     });
        // }
      },
      {
        path: 'tasks/car/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'carTasks',
        component: CarTasks,
        meta: {
          titleKey: 'carTasks',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        }
      },
      {
        path: 'pap-detail/:id([0-9]+)',
        name: 'papDetail',
        component: PapDetail,
        meta: {
          titleKey: 'papDetail',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        }
      },
      {
        path: 'discrepancies-detail/:idTransport([0-9]+)',
        name: 'discrepancyDetail',
        component: DiscrepancyDetail,
        meta: {
          titleKey: 'discrepancyDetail',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        }
      }
    ]
  }
];
